import {Box} from '@mui/system'
import React from 'react'
import { getImagePath } from '../utility'

export type ImageT = {
    height?: string | number,
    width?: string | number,
    image: string | number,
    center?: string | number,
    children?: JSX.Element
}

const ImageBackground = ({height, width, image, center, children, ...props}: ImageT & any) => {
    const resolvedImageUrl = resolveImageUrl(image);

    return (
        <Box
            height={height ?? 1}
            width={width ?? 1}
            {...props}
            sx={{
                backgroundImage: !resolvedImageUrl ? undefined : `url("${resolvedImageUrl}")`,
                backgroundPosition: center ?? "0%, 0%",
                backgroundSize: 'cover',
                ...props?.sx,
            }}>
            {children}</Box>
    )
}

function resolveImageUrl(image: ImageT["image"]) {
    const rawInput = typeof image === "string" ? image : String(image);
    const rawUrl = getImagePath(rawInput);
    if (!rawUrl) return "";

    // Keep URL readable, but make it safe inside CSS url("...").
    // - quotes would break the CSS string
    // - backslashes can appear in some paths and should be normalized
    return rawUrl.replaceAll("\\", "/").replaceAll('"', "%22");
}

export default ImageBackground;
